import { isUiModeDeveloper, isUiModeProductAdmin } from "../../uiMode";
import { itx, noItx } from "../../translationItx/itx";
import type KnxContext from "./KnxContext";
import { useState } from "react";

export default function KnxDebugElement(props: {
  item: any;
  nestedName: string;
  id: string;
  instanceId: string;
  knxContext: KnxContext;
}): any {
  const { item, nestedName, id, instanceId, knxContext } = props;

  const [collapsed, setCollapsed] = useState(true);

  const val1 = knxContext.getValue(id, instanceId);
  const val2 = knxContext.getValue(id, instanceId, false, true);

  let xval = val1;
  if (val1 != val2) {
    xval = `${val1} / ${val2}`;
  }

  const currentLevel = knxContext.knxInstanceData.getLevel(id, instanceId);

  return (
    <div className="knxDebug" style={{ userSelect: "text" }}>
      <div style={{ cursor: "pointer" }} className="parameterDebugDots" onClick={() => setCollapsed(!collapsed)}>
        D
      </div>
      <div
        style={{
          display: collapsed ? "none" : "inherit",
          whiteSpace: "nowrap",
        }}
      >
        {itx("KnxParameterViewer.name", "name=")}
        {knxContext.getName(item)} <br />
        {noItx("nestedName=")} {noItx("nestedName=")}
        {nestedName} <br />
        {noItx("type=")} {item.a.ParameterType}
        <br />
        {noItx("id=")}
        {id}
        <br />
        {noItx("instanceId=")} {instanceId}
        <br />
        {noItx("value=")} {xval}
        <br />
        {noItx("level=")} {currentLevel}
        <br />
      </div>
    </div>
  );
}
